import CCGauge from "../Common/CCGauge";
import {prepareBuffer} from "../../util/Buffer";

class ExampleGauge extends CCGauge {
    constructor(props) {
        super(props);

        this.state.fetchBackgroundOperation = false
    };

    componentDidMount() {
        super.componentDidMount();

        this.setState({Loading: this.state.fetchBackgroundOperation, Value: 72});

        this.applet.getEnterpriseComponent().executeQuery(1,100000);
    }

    enterpriseComponentLoadStarted = () => {
        this.setState({Loading: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
        let buffer = prepareBuffer(ec);

        // Average of Y_AXIS_1 across the buffer — single scalar for the gauge.
        let value = 0;
        if (buffer.length > 0) {
            let total = 0;
            for (let i = 0; i < buffer.length; i++) {
                total += parseFloat(buffer[i].get("Y_AXIS_1")) || 0;
            }
            value = Math.round(total / buffer.length);
        }

        this.setState({Loading: false, Value: value});
    };
}

export default ExampleGauge;
